import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { RecoverPasswordResponse } from '../../responses/admin-user/recover-password.response';

@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordService extends CommonService {

  constructor(private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public recoverPasswordToken(login: string): Observable<RecoverPasswordResponse> {

    let body = { login: login };

    return this.httpClient.post<RecoverPasswordResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorUser) + "AdminRecoverPassword", body)
      .pipe(
        catchError(this.handleError)
      )
  }
}